import type { WarehouseCode } from '../product/filter/state/warehouse';

export type WarehouseConfigItem = {
  readonly uuid: string;
  readonly code: WarehouseCode;
  readonly name: string;
};

export const WarehouseConfig = {
  pardubice: {
    uuid: '01997f77-d451-7396-8d89-23b42c3cfa6a',
    code: 'pardubice',
    name: 'Pardubice',
  },
  chrudim: {
    uuid: '01997f77-d44d-73f9-b0c0-aaf0d0f7eaf0',
    code: 'chrudim',
    name: 'Chrudim',
  },
} as const satisfies Record<string, WarehouseConfigItem>;

export const warehouseConfigArray = Object.values(WarehouseConfig);

export const getWarehouseByCode = (code: WarehouseCode): WarehouseConfigItem => {
  return WarehouseConfig[code];
};

export const getWarehouseUuidByCode = (code: WarehouseCode): string => {
  return WarehouseConfig[code].uuid;
};

export const getWarehouseNameByCode = (code: WarehouseCode): string => {
  return WarehouseConfig[code].name;
};

export const getWarehouseCodeByUuid = (uuid: string): WarehouseCode | null => {
  for (const warehouse of warehouseConfigArray) {
    if (warehouse.uuid === uuid) {
      return warehouse.code;
    }
  }
  return null;
};
